<template>
  <div :class="classes">
    <div class="products-item-matching-title">
      <feature-flag name="utility-score">
        <score v-if="matchingPercentage" :percentage="matchingPercentage" />
      </feature-flag>
      <div class="products-item-matching-title-text-and-arrow" @click="onClick">
        <span :id="matchingListTitleId" class="products-item-matching-title-text">{{ matchingTitle }}</span>
        <svg v-if="isListExpanded" class="products-item-matching-title-arrow-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 20L16 10L26 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <svg v-else class="products-item-matching-title-arrow-icon" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26 12L16 22L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
// @flow

import Score from '../Score/Score.vue'

export default {
  components: {
    Score
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: Object,
      default: () => {
      }
    },
    isListExpanded: {
      type: Boolean,
      default: () => false
    },
    keepExpanded: {
      type: Boolean,
      default: () => false
    },
    onClick: {
      type: Function,
      default: () => () => {
      }
    },
    matchingListTitleId: {
      type: String,
      default: ''
    }
  },
  computed: {
    matchingPercentage (): number {
      if (!this.item.utility || this.item.utility < 0) return

      return Math.ceil(this.item.utility * 100)
    },
    classes () {
      return {
        'products-item-matching': true,
        'products-item-matching--keep-expanded': this.keepExpanded
      }
    },
    matchingTitle (): string {
      return this.message.content.attributeMatchesPanelTitle || this.$t('product.matchingPanelTitle')
    }
  }
}
</script>

<style src="./attribute-matching.scss" />
